import { CheckUser, usePaymentData } from '@p2p/entities/payment';
import { CHECKED_USER_LOCAL_STORAGE_KEY, MSP_PAGE, PROOF_PAGE } from '@p2p/shared/constants';
import { useNavigate } from 'react-router-dom';

export const CheckUserPage = () => {
  const { order, pageSettings } = usePaymentData();
  const navigate = useNavigate();

  const handleSuccess = () => {
    // P2P-2880: проверку Cloudflare проходят и на msp_page, и на proof_page.
    const pagePath = order.payment_form === 'proof_page' ? PROOF_PAGE : MSP_PAGE;
    navigate(`${pagePath}/${order.id}`);
    localStorage.setItem(CHECKED_USER_LOCAL_STORAGE_KEY, order.id);
  };

  return <CheckUser pageSettings={pageSettings} onSuccess={handleSuccess} />;
};
